import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { InitialItemsQuery } from '../../graphql/graphql';
import { ResidenceCard } from '../Cards/ResidencesCard';
import { CardsLayout } from '../ui/CardsLayout';
import { NewSection } from '../NewSection';
import { getInitialItems } from '../../api/queries';
import { ItemsPlaceholder } from '../Placeholders/ItemsPlaceholder';
import { SectionError } from '../SectionError/SectionError';
import { ITEMS_LIMIT } from '../../utils/constants/homePage';

export const ResidencesSection: React.FC = () => {
  const { t } = useTranslation();
  const { data, loading, error, refetch } = useQuery<InitialItemsQuery>(
    getInitialItems,
    {
      variables: {
        limit: ITEMS_LIMIT,
        offset: 0
      }
    }
  );

  const residences = data?.residences || [];
  const residencesList = useMemo(
    () =>
      residences.map(residence => (
        <ResidenceCard
          key={residence.id}
          {...residence}
          cypress="residence-card-link"
          hideExcessItems
          priority
          stat="residence-card-link"
        />
      )),
    [residences]
  );

  const content = error ? (
    <SectionError onRetry={() => refetch()} />
  ) : (
    <CardsLayout>{residencesList}</CardsLayout>
  );

  return (
    <NewSection
      id="home-page-residences"
      title={t('sections.residences.title')}
      url="/yasayis-kompleksleri"
      asLink="/yasayis-kompleksleri"
      urlTitle={t('sections.residences.show_all')}
      cypress="residences-section-title"
    >
      {!(loading && !residencesList.length) ? (
        content
      ) : (
        <ItemsPlaceholder isCardsLayout noHeader />
      )}
    </NewSection>
  );
};
